import Axios from "axios"
import { orderBy } from "lodash"
import { API_ADMIN } from "../../utils/constants/Api"
import { ProductModel } from "../models/ProductModel"

export default {
    getProductList():Promise<ProductModel[]> {
        return Axios.get(`${API_ADMIN}products`)
            .then(({data}) => {
                return orderBy(data.map((s:ProductModel) => new ProductModel(s)), ['name'], ['asc'])
            })
    },
    getProductById(id:string):Promise<ProductModel> {
        return Axios.get(`${API_ADMIN}products/${id}`)
            .then(({data}) => {
                return new ProductModel(data)
            })
    },
}


